type Nationality = {
	uuid: string;
	label: string;
	value: string;
};

export const nationalities: Nationality[] = [
	{
		uuid: "9e67c952-a60b-478f-b691-ac848840f9f6",
		label: "Afghan",
		value: "AFGHAN",
	},
	{
		uuid: "9e67c952-a61a-470e-b254-a34f9748a434",
		label: "Albanian",
		value: "ALBANIAN",
	},
	{
		uuid: "9e67c952-a61e-4f60-ab53-da894eb4096f",
		label: "Algerian",
		value: "ALGERIAN",
	},
	{
		uuid: "9e67c952-a621-443b-bdde-7ecbdd681323",
		label: "American",
		value: "AMERICAN",
	},
	{
		uuid: "9e67c952-a624-4c28-8874-f13c6d5b517a",
		label: "Andorran",
		value: "ANDORRAN",
	},
	{
		uuid: "9e67c952-a626-488b-979e-c79013f5a504",
		label: "Angolan",
		value: "ANGOLAN",
	},
	{
		uuid: "9e67c952-a629-41fc-8b5f-1ff330d99b7e",
		label: "Antiguan",
		value: "ANTIGUAN",
	},
	{
		uuid: "9e67c952-a62b-461d-b6f3-f0111482b752",
		label: "Argentine",
		value: "ARGENTINE",
	},
	{
		uuid: "9e67c952-a62e-452e-808b-60353298f59d",
		label: "Armenian",
		value: "ARMENIAN",
	},
	{
		uuid: "9e67c952-a630-4f93-8c78-453990009da8",
		label: "Australian",
		value: "AUSTRALIAN",
	},
	{
		uuid: "9e67c952-a632-4cba-969d-118423ced4f5",
		label: "Austrian",
		value: "AUSTRIAN",
	},
	{
		uuid: "9e67c952-a634-49b7-83f6-947af7c4d8a4",
		label: "Azerbaijani",
		value: "AZERBAIJANI",
	},
	{
		uuid: "9e67c952-a638-435f-b324-993c9a95545d",
		label: "Bahaman",
		value: "BAHAMAN",
	},
	{
		uuid: "9e67c952-a63b-4209-93e8-ba7bb9df41e2",
		label: "Bahraini",
		value: "BAHRAINI",
	},
	{
		uuid: "9e67c952-a63e-4fdd-a2ba-3ea96f2c2c83",
		label: "Bangladeshi",
		value: "BANGLADESHI",
	},
	{
		uuid: "9e67c952-a641-47df-8bee-b4ee6d9bc323",
		label: "Barbadian",
		value: "BARBADIAN",
	},
	{
		uuid: "9e67c952-a644-4b68-8c5e-ba8169e79890",
		label: "Barbudan",
		value: "BARBUDAN",
	},
	{
		uuid: "9e67c952-a646-4c61-9ad8-3ce0cd4d111e",
		label: "Batswana",
		value: "BATSWANA",
	},
	{
		uuid: "9e67c952-a649-4ac4-8fef-79a310a967f7",
		label: "Belarusian",
		value: "BELARUSIAN",
	},
	{
		uuid: "9e67c952-a64c-40f2-85be-4b5310de3668",
		label: "Belgian",
		value: "BELGIAN",
	},
	{
		uuid: "9e67c952-a64e-4e58-b294-47d4c2c2d2dc",
		label: "Belizean",
		value: "BELIZEAN",
	},
	{
		uuid: "9e67c952-a651-4938-b693-372553626293",
		label: "Beninese",
		value: "BENINESE",
	},
	{
		uuid: "9e67c952-a653-4fbf-ab95-8de56707918d",
		label: "Bhutanese",
		value: "BHUTANESE",
	},
	{
		uuid: "9e67c952-a656-4782-b1ad-4593edaaa44b",
		label: "Bolivian",
		value: "BOLIVIAN",
	},
	{
		uuid: "9e67c952-a65a-43d7-bdea-88127bb018b8",
		label: "Bosnian",
		value: "BOSNIAN",
	},
	{
		uuid: "9e67c952-a65c-483a-94c5-eb947c20d381",
		label: "Botswana",
		value: "BOTSWANA",
	},
	{
		uuid: "9e67c952-a65f-4a2b-9eca-ab79f2b90659",
		label: "Brazilian",
		value: "BRAZILIAN",
	},
	{
		uuid: "9e67c952-a661-4d86-8cf8-f58caa40426e",
		label: "Bruneian",
		value: "BRUNEIAN",
	},
	{
		uuid: "9e67c952-a664-40dd-9b13-7f9c8ff0be02",
		label: "Bulgarian",
		value: "BULGARIAN",
	},
	{
		uuid: "9e67c952-a667-44a4-a919-b5f25b892dde",
		label: "Burkinabé",
		value: "BURKINABE",
	},
	{
		uuid: "9e67c952-a669-49fc-bb90-253647180ff2",
		label: "Burundian",
		value: "BURUNDIAN",
	},
	{
		uuid: "9e67c952-a66c-4105-9d68-0882744f2ea3",
		label: "Cabo Verdean",
		value: "CABO VERDEAN",
	},
	{
		uuid: "9e67c952-a66e-4b7b-a497-52817c162a31",
		label: "Cambodian",
		value: "CAMBODIAN",
	},
	{
		uuid: "9e67c952-a671-42bf-9768-b7562ae14cbc",
		label: "Cameroonian",
		value: "CAMEROONIAN",
	},
	{
		uuid: "9e67c952-a673-4ba0-b570-3c363776ebaa",
		label: "Canadian",
		value: "CANADIAN",
	},
	{
		uuid: "9e67c952-a676-408f-956b-944a4e15031d",
		label: "Chadian",
		value: "CHADIAN",
	},
	{
		uuid: "9e67c952-a679-4f47-95e1-929893b150b1",
		label: "Chilean",
		value: "CHILEAN",
	},
	{
		uuid: "9e67c952-a67b-4a0b-91af-8491b35efa4d",
		label: "Chinese",
		value: "CHINESE",
	},
	{
		uuid: "9e67c952-a67e-483d-965b-0e6519fe6dd3",
		label: "Colombian",
		value: "COLOMBIAN",
	},
	{
		uuid: "9e67c952-a680-434f-9d70-79402a0290ae",
		label: "Comorian",
		value: "COMORIAN",
	},
	{
		uuid: "9e67c952-a682-44db-a6ee-52b7f1f26e24",
		label: "Congolese",
		value: "CONGOLESE",
	},
	{
		uuid: "9e67c952-a685-4dfa-9eeb-e1cedde347f0",
		label: "Costa Rican",
		value: "COSTA RICAN",
	},
	{
		uuid: "9e67c952-a688-40a9-808b-78224e1040dc",
		label: "Croatian",
		value: "CROATIAN",
	},
	{
		uuid: "9e67c952-a68a-4703-b86a-6d2513058d80",
		label: "Cuban",
		value: "CUBAN",
	},
	{
		uuid: "9e67c952-a68d-4d13-8d9b-5c10f075c734",
		label: "Cypriot",
		value: "CYPRIOT",
	},
	{
		uuid: "9e67c952-a68f-47ff-ba82-3ad4a57fea1b",
		label: "Czech",
		value: "CZECH",
	},
	{
		uuid: "9e67c952-a692-4432-9bdf-0f058368611b",
		label: "Danish",
		value: "DANISH",
	},
	{
		uuid: "9e67c952-a697-4648-b798-24ce07238a0b",
		label: "Djiboutian",
		value: "DJIBOUTIAN",
	},
	{
		uuid: "9e67c952-a699-4e8f-9758-b86c823216ff",
		label: "Dominican",
		value: "DOMINICAN",
	},
	{
		uuid: "9e67c952-a69c-49f0-89fc-2d25871ad7b9",
		label: "Dutch",
		value: "DUTCH",
	},
	{
		uuid: "9e67c952-a69f-4a85-bb28-2fefbc76a54a",
		label: "East Timorese",
		value: "EAST TIMORESE",
	},
	{
		uuid: "9e67c952-a6a1-4b9b-bf34-36873479fade",
		label: "Ecuadorean",
		value: "ECUADOREAN",
	},
	{
		uuid: "9e67c952-a6a4-484d-8858-758df4d93e18",
		label: "Egyptian",
		value: "EGYPTIAN",
	},
	{
		uuid: "9e67c952-a6a6-4eca-9330-ba803550c34f",
		label: "Emirati",
		value: "EMIRATI",
	},
	{
		uuid: "9e67c952-a6a9-4b82-9bf0-684b60cd676f",
		label: "Equatorial Guinean",
		value: "EQUATORIAL GUINEAN",
	},
	{
		uuid: "9e67c952-a6ab-4791-ad99-35598b214813",
		label: "Eritrean",
		value: "ERITREAN",
	},
	{
		uuid: "9e67c952-a6af-4ad0-8657-df8697af3157",
		label: "Estonian",
		value: "ESTONIAN",
	},
	{
		uuid: "9e67c952-a6b2-4b74-ab2d-f6b662121a26",
		label: "Ethiopian",
		value: "ETHIOPIAN",
	},
	{
		uuid: "9e67c952-a6b5-45de-b9df-a4b3236eebc3",
		label: "Fijian",
		value: "FIJIAN",
	},
	{
		uuid: "9e67c952-a6b7-4fef-9941-3e4603cd1f4b",
		label: "Filipino",
		value: "FILIPINO",
	},
	{
		uuid: "9e67c952-a6bb-4900-9ab2-cc513dcff0f3",
		label: "Finnish",
		value: "FINNISH",
	},
	{
		uuid: "9e67c952-a6be-4791-ba86-a2e2ebff3943",
		label: "French",
		value: "FRENCH",
	},
	{
		uuid: "9e67c952-a6c1-4c8a-bc77-10e0b7e0144c",
		label: "Gabonese",
		value: "GABONESE",
	},
	{
		uuid: "9e67c952-a6c3-4d33-ad2c-aed38a5d8a14",
		label: "Gambian",
		value: "GAMBIAN",
	},
	{
		uuid: "9e67c952-a6c6-4787-b521-a19a89883f69",
		label: "Georgian",
		value: "GEORGIAN",
	},
	{
		uuid: "9e67c952-a6c8-464a-85f3-abb60d85a7fa",
		label: "Ghanaian",
		value: "GHANAIAN",
	},
	{
		uuid: "9e67c952-a6cb-4933-9380-6b6438bc6398",
		label: "Grecian",
		value: "GRECIAN",
	},
	{
		uuid: "9e67c952-a6cd-46e8-9876-e24644599257",
		label: "Grenadian",
		value: "GRENADIAN",
	},
	{
		uuid: "9e67c952-a6d0-45fa-ad07-6a4f2437d7a6",
		label: "Guatemalan",
		value: "GUATEMALAN",
	},
	{
		uuid: "9e67c952-a6d2-47f6-b7e1-9bf57a6fdb6e",
		label: "Guinea-Bissauan",
		value: "GUINEA-BISSAUAN",
	},
	{
		uuid: "9e67c952-a6d5-4460-add4-0b5f576092b0",
		label: "Guinean",
		value: "GUINEAN",
	},
	{
		uuid: "9e67c952-a6d9-40e9-a0dc-593ea067d281",
		label: "Guyanese",
		value: "GUYANESE",
	},
	{
		uuid: "9e67c952-a6db-4d08-ad3e-75c77c82c423",
		label: "Haitian",
		value: "HAITIAN",
	},
	{
		uuid: "9e67c952-a6de-4048-900a-9276be027e3d",
		label: "Honduran",
		value: "HONDURAN",
	},
	{
		uuid: "9e67c952-a6e1-4e4d-8f7f-6bcc73b9cc05",
		label: "Hungarian",
		value: "HUNGARIAN",
	},
	{
		uuid: "9e67c952-a6e3-4b76-9721-0aa7c4268129",
		label: "Icelander",
		value: "ICELANDER",
	},
	{
		uuid: "9e67c952-a6e6-4140-81e8-d08f088433a5",
		label: "Indian",
		value: "INDIAN",
	},
	{
		uuid: "9e67c952-a6e8-473b-a4ac-b98f6b89723b",
		label: "Indonesian",
		value: "INDONESIAN",
	},
	{
		uuid: "9e67c952-a6eb-43e2-afe2-ef8bd483cf53",
		label: "Iranian",
		value: "IRANIAN",
	},
	{
		uuid: "9e67c952-a6ee-4411-bcda-d54e7fbbe46c",
		label: "Iraqi",
		value: "IRAQI",
	},
	{
		uuid: "9e67c952-a6f0-4370-bb0c-0e159d82f789",
		label: "Irish",
		value: "IRISH",
	},
	{
		uuid: "9e67c952-a6f3-4289-997d-c60928d6e7b5",
		label: "Israeli",
		value: "ISRAELI",
	},
	{
		uuid: "9e67c952-a6f5-4411-b793-46f8c953dd4b",
		label: "Italian",
		value: "ITALIAN",
	},
	{
		uuid: "9e67c952-a6f8-4dc8-bc4d-b4dc44f787a2",
		label: "Ivorian",
		value: "IVORIAN",
	},
	{
		uuid: "9e67c952-a6fa-4d35-8edd-f17d76a2b1c6",
		label: "Jamaican",
		value: "JAMAICAN",
	},
	{
		uuid: "9e67c952-a6fd-477f-8e5e-64be0ad94dae",
		label: "Japanese",
		value: "JAPANESE",
	},
	{
		uuid: "9e67c952-a6ff-4136-b964-1460d04df1b7",
		label: "Jordanian",
		value: "JORDANIAN",
	},
	{
		uuid: "9e67c952-a702-427b-98f3-2567c6bfff0b",
		label: "Kazakh",
		value: "KAZAKH",
	},
	{
		uuid: "9e67c952-a704-4816-abd5-28be0b9d4b0e",
		label: "Kenyan",
		value: "KENYAN",
	},
	{
		uuid: "9e67c952-a707-41d6-bad0-c4cd458640c2",
		label: "Kittitian",
		value: "KITTITIAN",
	},
	{
		uuid: "9e67c952-a70a-4682-a529-ea9b3d0a3c1d",
		label: "Kuwaiti",
		value: "KUWAITI",
	},
	{
		uuid: "9e67c952-a70c-47fa-94b2-606574515c61",
		label: "Kyrgyzstani",
		value: "KYRGYZSTANI",
	},
	{
		uuid: "9e67c952-a70f-40f4-adaa-be045e7db619",
		label: "Laotian",
		value: "LAOTIAN",
	},
	{
		uuid: "9e67c952-a711-424b-a464-5248fd547b03",
		label: "Latvian",
		value: "LATVIAN",
	},
	{
		uuid: "9e67c952-a714-46d6-80f2-fc7d532cd703",
		label: "Lebanese",
		value: "LEBANESE",
	},
	{
		uuid: "9e67c952-a716-47c6-abf1-a98cd8f69632",
		label: "Lesotho",
		value: "LESOTHO",
	},
	{
		uuid: "9e67c952-a719-4121-a869-4a84bc4efe2e",
		label: "Liberian",
		value: "LIBERIAN",
	},
	{
		uuid: "9e67c952-a71b-49cc-bdae-4a77f96591bc",
		label: "Libyan",
		value: "LIBYAN",
	},
	{
		uuid: "9e67c952-a71e-4ae2-9604-16711a7f840d",
		label: "Liechtenstein",
		value: "LIECHTENSTEIN",
	},
	{
		uuid: "9e67c952-a720-4912-85b4-b7c235a91641",
		label: "Lithuanian",
		value: "LITHUANIAN",
	},
	{
		uuid: "9e67c993-f9c0-4584-bfd4-9788742bbbec",
		label: "Luxembourgish",
		value: "LUXEMBOURGISH",
	},
	{
		uuid: "9e67c993-f9d2-4f9d-b35b-bf0bd260c4dd",
		label: "Macedonian",
		value: "MACEDONIAN",
	},
	{
		uuid: "9e67c993-f9d8-4396-9d35-f9370ddab264",
		label: "Malagasy",
		value: "MALAGASY",
	},
	{
		uuid: "9e67c993-f9dd-4cd9-9db2-2697422e01e7",
		label: "Malawian",
		value: "MALAWIAN",
	},
	{
		uuid: "9e67c993-f9e0-481e-b945-4af93bd5cc9e",
		label: "Malaysian",
		value: "MALAYSIAN",
	},
	{
		uuid: "9e67c993-f9e3-473c-8b69-84ced457f7a7",
		label: "Maldivian",
		value: "MALDIVIAN",
	},
	{
		uuid: "9e67c993-f9e6-45c9-ab51-4dff074bf2c1",
		label: "Malian",
		value: "MALIAN",
	},
	{
		uuid: "9e67c993-f9e9-4eb0-9b53-6d03e7c4d374",
		label: "Malta",
		value: "MALTA",
	},
	{
		uuid: "9e67c993-f9ec-418f-8be3-15c1344b329d",
		label: "Marshallese",
		value: "MARSHALLESE",
	},
	{
		uuid: "9e67c993-f9ef-4739-91eb-fbee1996bdfb",
		label: "Mauritian",
		value: "MAURITIAN",
	},
	{
		uuid: "9e67c993-f9f4-4f9d-91db-c16d177bbf9a",
		label: "Mauritian",
		value: "MAURITIAN",
	},
	{
		uuid: "9e67c993-f9f7-457d-9999-7aae66beefb7",
		label: "Mexican",
		value: "MEXICAN",
	},
	{
		uuid: "9e67c993-f9fa-4bb9-9e67-ef4e021ea287",
		label: "Micronesian",
		value: "MICRONESIAN",
	},
	{
		uuid: "9e67c993-f9fd-4f96-b0f9-f5be7bd12297",
		label: "Moldovan",
		value: "MOLDOVAN",
	},
	{
		uuid: "9e67c993-f9ff-437c-8f22-8a8410982eed",
		label: "Monacan",
		value: "MONACAN",
	},
	{
		uuid: "9e67c993-fa02-4cf1-b493-057eb8e7abee",
		label: "Mongolian",
		value: "MONGOLIAN",
	},
	{
		uuid: "9e67c993-fa09-41d4-aefa-64c453008988",
		label: "Montenegrin",
		value: "MONTENEGRIN",
	},
	{
		uuid: "9e67c993-fa0b-4836-b20d-38a17141b043",
		label: "Moroccan",
		value: "MOROCCAN",
	},
	{
		uuid: "9e67c993-fa0e-42e3-a6a1-5f87a6f9e0ac",
		label: "Mozambican",
		value: "MOZAMBICAN",
	},
	{
		uuid: "9e67c993-fa11-4f21-b238-87ebadf1e760",
		label: "Namibian",
		value: "NAMIBIAN",
	},
	{
		uuid: "9e67c993-fa14-4645-ac6d-29fe3a989149",
		label: "Nauruan",
		value: "NAURUAN",
	},
	{
		uuid: "9e67c993-fa16-4495-8c3a-c2da11202144",
		label: "Nepalese",
		value: "NEPALESE",
	},
	{
		uuid: "9e67c993-fa19-485a-a596-99220a01828c",
		label: "New Zealander",
		value: "NEW ZEALANDER",
	},
	{
		uuid: "9e67c993-fa1c-4a6c-aa51-dd2731affdec",
		label: "Nicaraguan",
		value: "NICARAGUAN",
	},
	{
		uuid: "9e67c993-fa1f-4c82-91f6-09b2aadb2d72",
		label: "Nigerian",
		value: "NIGERIAN",
	},
	{
		uuid: "9e67c993-fa21-485a-8af2-2889a4e3fbf5",
		label: "Nigerien",
		value: "NIGERIEN",
	},
	{
		uuid: "9e67c993-fa24-4749-bbe1-8eb834a9fa28",
		label: "North Korean",
		value: "NORTH KOREAN",
	},
	{
		uuid: "9e67c993-fa27-446d-ab12-7d3d28180c78",
		label: "Northern Mariana Islander",
		value: "NORTHERN MARIANA ISLANDER",
	},
	{
		uuid: "9e67c993-fa29-4581-a268-1b02fa47e135",
		label: "Norwegian",
		value: "NORWEGIAN",
	},
	{
		uuid: "9e67c993-fa2e-421d-9cb9-722c4c003601",
		label: "Omani",
		value: "OMANI",
	},
	{
		uuid: "9e67c993-fa30-47c0-9410-ea8575a8aa4e",
		label: "Pakistani",
		value: "PAKISTANI",
	},
	{
		uuid: "9e67c993-fa33-4e91-ae08-bdf57653659d",
		label: "Palauan",
		value: "PALAUAN",
	},
	{
		uuid: "9e67c993-fa36-4258-a151-41e95513d976",
		label: "Panamanian",
		value: "PANAMANIAN",
	},
	{
		uuid: "9e67c993-fa39-480e-bff0-da9f7642eafd",
		label: "Papua New Guinean",
		value: "PAPUA NEW GUINEAN",
	},
	{
		uuid: "9e67c993-fa3b-48c6-a1b8-2f9d8302364d",
		label: "Paraguayan",
		value: "PARAGUAYAN",
	},
	{
		uuid: "9e67c993-fa3e-4631-8829-50f239d823a8",
		label: "Peruvian",
		value: "PERUVIAN",
	},
	{
		uuid: "9e67c993-fa41-4ad1-b018-bd2a2cb0b41e",
		label: "Philippine",
		value: "PHILIPPINE",
	},
	{
		uuid: "9e67c993-fa44-4e1f-a870-96ae04ead899",
		label: "Polish",
		value: "POLISH",
	},
	{
		uuid: "9e67c993-fa47-40d9-93ab-736a1e068e82",
		label: "Portuguese",
		value: "PORTUGUESE",
	},
	{
		uuid: "9e67c993-fa49-4983-92b7-01829ccec986",
		label: "Qatari",
		value: "QATARI",
	},
	{
		uuid: "9e67c993-fa4c-43de-ac33-430f55c33800",
		label: "Romanian",
		value: "ROMANIAN",
	},
	{
		uuid: "9e67c993-fa4f-427f-8705-eac1cf76fa8e",
		label: "Russian",
		value: "RUSSIAN",
	},
	{
		uuid: "9e67c993-fa51-425f-8606-00e489ab2432",
		label: "Rwandan",
		value: "RWANDAN",
	},
	{
		uuid: "9e67c993-fa54-4f78-ba4b-02bdf144c856",
		label: "Saint Kitts and Nevis",
		value: "SAINT KITTS AND NEVIS",
	},
	{
		uuid: "9e67c993-fa56-4198-8e1c-5c48c102e4bd",
		label: "Saint Lucian",
		value: "SAINT LUCIAN",
	},
	{
		uuid: "9e67c993-fa59-490a-93ae-7362d3597c66",
		label: "Saint Vincentian",
		value: "SAINT VINCENTIAN",
	},
	{
		uuid: "9e67c993-fa5c-48a6-99b7-21012112ca37",
		label: "Samoan",
		value: "SAMOAN",
	},
	{
		uuid: "9e67c993-fa5f-4f40-85c5-0d79502bb5a8",
		label: "San Marinese",
		value: "SAN MARINESE",
	},
	{
		uuid: "9e67c993-fa61-4171-846e-962733803847",
		label: "Sao Tomean",
		value: "SAO TOMEAN",
	},
	{
		uuid: "9e67c993-fa64-4c03-a8fc-6b02011a1421",
		label: "Saudi Arabian",
		value: "SAUDI ARABIAN",
	},
	{
		uuid: "9e67c993-fa67-4b49-86e5-e89954c8f4c7",
		label: "Senegalese",
		value: "SENEGALESE",
	},
	{
		uuid: "9e67c993-fa69-4175-b904-793db41ca610",
		label: "Serbian",
		value: "SERBIAN",
	},
	{
		uuid: "9e67c993-fa6c-41b6-8ade-91b5484547fb",
		label: "Seychellois",
		value: "SEYCHELLOIS",
	},
	{
		uuid: "9e67c993-fa70-4950-8830-127ae7b88a6a",
		label: "Sierra Leonean",
		value: "SIERRA LEONEAN",
	},
	{
		uuid: "9e67c993-fa73-4136-b0df-caba799b656d",
		label: "Singaporean",
		value: "SINGAPOREAN",
	},
	{
		uuid: "9e67c993-fa75-41b8-b0dd-03ea99ada1ee",
		label: "Slovakian",
		value: "SLOVAKIAN",
	},
	{
		uuid: "9e67c993-fa78-4366-918c-5fd32b7beb7e",
		label: "Slovenian",
		value: "SLOVENIAN",
	},
	{
		uuid: "9e67c993-fa7b-4e39-9a62-2e1cb594fde4",
		label: "Solomon Islander",
		value: "SOLOMON ISLANDER",
	},
	{
		uuid: "9e67c993-fa7e-4e2d-a8ac-be905aff6599",
		label: "Somali",
		value: "SOMALI",
	},
	{
		uuid: "9e67c993-fa80-48a9-bb01-6a3e704ff4ce",
		label: "South African",
		value: "SOUTH AFRICAN",
	},
	{
		uuid: "9e67c993-fa83-453a-899c-53dbd71f81c6",
		label: "South Korean",
		value: "SOUTH KOREAN",
	},
	{
		uuid: "9e67c993-fa86-40aa-bc32-e01329b26906",
		label: "Spanish",
		value: "SPANISH",
	},
	{
		uuid: "9e67c993-fa89-488a-9bfc-6c3134417ed3",
		label: "Sri Lankan",
		value: "SRI LANKAN",
	},
	{
		uuid: "9e67c993-fa8b-46a6-9812-13fca8a8e929",
		label: "Sudanese",
		value: "SUDANESE",
	},
	{
		uuid: "9e67c993-fa8e-4ab5-adaf-364601aed14a",
		label: "Surinamese",
		value: "SURINAMESE",
	},
	{
		uuid: "9e67c993-fa91-4050-89a6-e5bf2ec566c1",
		label: "Swazi",
		value: "SWAZI",
	},
	{
		uuid: "9e67c993-fa93-4d2e-863c-afe0a2494d88",
		label: "Swedish",
		value: "SWEDISH",
	},
	{
		uuid: "9e67c993-fa96-4cce-a140-24eae68c2843",
		label: "Swiss",
		value: "SWISS",
	},
	{
		uuid: "9e67c993-fa99-447a-954f-5918564ec9c1",
		label: "Syrian",
		value: "SYRIAN",
	},
	{
		uuid: "9e67c993-fa9c-48ad-b3f0-8401db015e90",
		label: "Taiwanese",
		value: "TAIWANESE",
	},
	{
		uuid: "9e67c993-fa9e-4a90-8ce8-05bbb3254666",
		label: "Tajik",
		value: "TAJIK",
	},
	{
		uuid: "9e67c993-faa1-4116-aa18-370ad95ad3cf",
		label: "Tanzanian",
		value: "TANZANIAN",
	},
	{
		uuid: "9e67c993-faa4-42a0-9d0d-cb870d014cb6",
		label: "Thai",
		value: "THAI",
	},
	{
		uuid: "9e67c993-faa6-48c4-af71-6d4e72a8a562",
		label: "Togolese",
		value: "TOGOLESE",
	},
	{
		uuid: "9e67c993-faa9-4ef3-b35c-ac6ada7f5beb",
		label: "Tongan",
		value: "TONGAN",
	},
	{
		uuid: "9e67c993-faac-4879-9664-0156609e26ba",
		label: "Trinidadian",
		value: "TRINIDADIAN",
	},
	{
		uuid: "9e67c993-faaf-4a4f-9790-67aa447c2cae",
		label: "Tunisian",
		value: "TUNISIAN",
	},
	{
		uuid: "9e67c993-fab2-42c4-a561-46912d46568c",
		label: "Turkmen",
		value: "TURKMEN",
	},
	{
		uuid: "9e67c993-fab4-4669-9bba-0da3c828c1f7",
		label: "Turkish",
		value: "TURKISH",
	},
	{
		uuid: "9e67c993-fab7-4e60-be9f-fe8288120e38",
		label: "Tuvaluan",
		value: "TUVALUAN",
	},
	{
		uuid: "9e67c993-faba-45e9-ab3e-b5b021361fbb",
		label: "Ugandan",
		value: "UGANDAN",
	},
	{
		uuid: "9e67c993-fabd-4f88-9f7c-6f4d8ba489ea",
		label: "Ukrainian",
		value: "UKRAINIAN",
	},
	{
		uuid: "9e67c993-fac0-4079-abbb-d5a169192b23",
		label: "Uruguayan",
		value: "URUGUAYAN",
	},
	{
		uuid: "9e67c993-fac2-4c5e-b280-1ba352e79ad9",
		label: "Uzbekistani",
		value: "UZBEKISTANI",
	},
	{
		uuid: "9e67c993-fac5-4ab5-8da3-4e96d2374652",
		label: "Vanuatuan",
		value: "VANUATUAN",
	},
	{
		uuid: "9e67c993-fac7-49f3-8be3-fda0bf415e57",
		label: "Venezuelan",
		value: "VENEZUELAN",
	},
	{
		uuid: "9e67c993-facb-4bef-8daa-d3a2d1a004e7",
		label: "Vietnamese",
		value: "VIETNAMESE",
	},
	{
		uuid: "9e67c993-face-4940-a14c-b22d4813d403",
		label: "Yemeni",
		value: "YEMENI",
	},
	{
		uuid: "9e67c993-fad1-4097-a3c5-2bfa852921f5",
		label: "Zambian",
		value: "ZAMBIAN",
	},
	{
		uuid: "9e67c993-fad4-4859-9739-43154bce5ff7",
		label: "Zimbabwean",
		value: "ZIMBABWEAN",
	},
];
